import { Injectable } from '@angular/core';
import { HttpClient} from '@angular/common/http'
import { Observable } from 'rxjs';
import { FormBuilder, FormGroup, Validators, FormControl, FormArray } from '@angular/forms';
import { User } from './database';


/*
interface ApiRequest {
  id: string;
  auth : string;        
  resource : string;      // Nome tabella database
  action : string;        // GET,POST,UPDATE,DELETE
  offset : number;
  limit : number;
  filters :string[];
  order : string;
  data : any[];           // Contenuto risorsa richiesta
}
*/

interface AuthData  {
  id_user: number,
  name: string,
  sid: string,
  auth: string
}

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  // TODO Variabili sessione, probabilmente da spostare in servizio dedicato "auth" ?!
  user_login: string;
  id_user: number;
  authData: AuthData;
  user: User;
  email: string;
  
  // Variabili condivise dagli utenti del servizio api
  id_eventyacht: number; 
  id_event: number;
  event_name: string;

  constructor(private http: HttpClient) {

    this.id_eventyacht = -1;  // Iscrizione non definita
    this.id_user = -1;        // Utente non definito
    this.authData = {
      id_user : 0,
      name : "",
      sid : "",
      auth : ""
    };
  }

  call(request:any){
    // console.log("ApiService::call = " + JSON.stringify(request));
   
    // Restituisco un Observable, delego la lettura asimcrona al client del servizio !
    return (this.http.post("api/api.php", request));

    // Commentata sotto la richiesta comnpleta...
    /*
    this.http.post("api/api.php",request).subscribe((data: any[]) => {
      this.reply = data;
      console.log("api.php reply : " +  JSON.stringify(data));
      // console.log("api.php reply : " + data);
      // console.log(data);
    });
    */
    // this.http.get("/api/api.php").subscribe((data:any[])=>{console.log("Rxjs OK")});
    // console.log("apiRequest.reply=" + this.reply);
  }

  login (userLogin:string,userPassword:string)
  {
    // TODO Studiare e realizzare richiesta simile a JWT con header.payload.signature
    // Utilizzare codifica base64url 

    // console.log ("api login called with userLogin="+userLogin + " and userPassword=" + userPassword);
    
    // Restituisco un Observable, delego la lettura asincrona al client del servizio !
    return (this.http.post("api/auth.php", {
      "id": "",
      "auth": "",
      "resource": "auth",
      "action": "login",
      "data": {
          "email" : userLogin,
          "sub" : userPassword,
          "sid" : ""
      }
    }
    ));
  }

  logout ()
  {
    // Logout, riassegno variabili utente ed iscrizione
    this.id_user = -1; 
    this.id_eventyacht = -1;
    this.authData = {
      id_user : 0,
      name : "",
      sid : "",
      auth : ""
    };
  }

  formArrayToApiData(formArray:FormArray){
    // Accetta in ingresso un array FormArray composto da FormGroup
    // e restituisce un oggetto composto da chiave/valore di ogni singolo
    var data = new Object();
    var formGroup: FormGroup;
    for (var i=0; i<formArray.length;i++)
    {
      formGroup = formArray.controls[i] as FormGroup;
      Object.keys(formGroup.controls).forEach((key:string)=>{
        const abstractControl = formGroup.get(key);
        // ATTENZIONE !! Restituisco solo campi non vuoti !!
        if (abstractControl.value != "")
          data[key] = abstractControl.value;  
      })
    }
    //console.log(JSON.stringify(data));
    // ATTENZIONE, restituisco un oggetto javascript e non la sua conversione in JSON con JSON.stringify(data)
    // Se lo facessi quando chiamo la funzione dentro l'object literal ottengo un JSON con caratteri escape \
    return(data);
  }

/*   uploadImage (imagePath:string, imageFile: <File>)
  {
    this.imagePath="allegati/"+event.target.files[0].name;
    this.imageFile = <File> event.target.files[0];   
  } */

}
